<template>
  <div class="generic-bg">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="page-img">
            <img :src="imageUrl" alt="vision-mision image" @error="setDefaultImg">
          </div>
          <div class="page-vision" v-html="pageDetails"></div>
          <div class="media-center news-details page-social-media">
            <social-media-sharing :share="Share" 
                                  :titleToShareOnSocial="pageTitle" 
                                  :descriptionToShareOnSocial="pageDescription"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialMediaSharing from '../SocialMediaSharing/SocialMediaSharing.vue';
import img from '../../../src/assets/default.png'

export default {
    name: 'Vision',
    components: { 
      SocialMediaSharing 
    },
    props:['pageDetails','imageUrl','Share','pageTitle','pageDescription'],
    methods:{
      setDefaultImg(e){
        e.target.src = img
      }
  }


}
</script>